import React from 'react';
import { useWatch } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { isWidthRequired } from './width-validation';
import { IProduct } from '../../../product-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

export function WidthInput() {
    const inputName: keyof IProduct = 'width';

    const orderProductionTypeIdName: keyof IProduct =
        'order_production_type_id';
    const orderProductionTypeId = useWatch({
        name: orderProductionTypeIdName,
    });

    if (!isWidthRequired({ order_production_type_id: orderProductionTypeId })) {
        return null;
    }

    return (
        <RhNumberField
            name={inputName}
            label={shortLabel(FIELD_LABELS.width)}
        />
    );
}
